import { render, staticRenderFns } from "./Guestbook.vue?vue&type=template&id=13c707bf&"
import script from "./Guestbook.vue?vue&type=script&lang=js&"
export * from "./Guestbook.vue?vue&type=script&lang=js&"
import style0 from "./Guestbook.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports